<template>
  <div class="ev-edit-daily-log">
    <!-- Header -->
    <div v-if="title" class="ev-edl-header">
      <h2 class="ev-section-title">
        <span class="ev-section-icon">📝</span>
        {{ title }}
      </h2>
    </div>

    <div class="ev-edl-content">
      <!-- Employee name & bulk delete -->
      <div class="ev-edl-toolbar">
        <div v-show="isMultiselect" class="ev-edl-toolbar-left">
          <button
            :disabled="!multipleRowsSelected"
            @click="deleteSelectedEvents"
            class="ev-btn ev-btn-danger ev-btn-sm"
          >
            🗑️ Obriši selektovane
          </button>
        </div>
        <div class="ev-edl-employee-info">
          <span class="ev-badge ev-badge-secondary">👤 {{ employeeName }}</span>
        </div>
      </div>

      <!-- Date label -->
      <div class="ev-edl-date-bar">
        <span class="ev-edl-date-label">Događaji na dan:</span>
        <span class="ev-edl-date-value">{{ logDate }}</span>
      </div>

      <!-- Table -->
      <div class="ev-edl-table">
        <vue-table-dynamic
          @cell-contextmenu="cmClicked"
          @selection-change="onSelectionChange"
          :params="params"
          ref="table"
        ></vue-table-dynamic>
      </div>

      <!-- Context Menu -->
      <context-menu :display="showContextMenu" ref="menu">
        <ul class="ev-context-menu-list">
          <li
            v-show="showContextMenuDeactivate"
            @click="cmDeactivateClicked"
            class="ev-context-menu-item ev-context-menu-item--danger"
          >
            <span class="ev-context-icon">🚫</span>
            Deaktiviraj
          </li>
          <li
            class="ev-context-menu-divider"
            v-show="showContextMenuForceDeparture"
          ></li>
          <li
            v-show="showContextMenuForceDeparture"
            @click="cmEditClicked(904)"
            class="ev-context-menu-item"
          >
            <span class="ev-context-icon">🏠</span>
            Promijeni u "odlazak sa posla"
          </li>
          <li
            v-show="showContextMenuForceDeparture"
            @click="cmEditClicked(901)"
            class="ev-context-menu-item"
          >
            <span class="ev-context-icon">💼</span>
            Promijeni u "službeni izlazak"
          </li>
          <li
            v-show="showContextMenuForceDeparture"
            @click="cmEditClicked(903)"
            class="ev-context-menu-item"
          >
            <span class="ev-context-icon">☕</span>
            Promijeni u "pauzu"
          </li>
          <li
            v-show="showContextMenuForceDeparture"
            @click="cmEditClicked(902)"
            class="ev-context-menu-item"
          >
            <span class="ev-context-icon">🔒</span>
            Promijeni u "privatni izlazak"
          </li>
          <li
            class="ev-context-menu-divider"
            v-show="showContextMenuForceDeparture"
          ></li>
          <li
            v-show="showContextMenuForceDeparture"
            @click="cmEditClicked(-1)"
            class="ev-context-menu-item ev-context-menu-item--muted"
          >
            <span class="ev-context-icon">✖️</span>
            Ukloni oznaku izlaska
          </li>
        </ul>
      </context-menu>
    </div>
  </div>
</template>

<script>
import {
  getAccessTypeFromAccessLog,
  getDeviceFromAccessLog,
  getEventFromAccessLog,
  ifArrayContainsObject,
  getLeavingReasonStringFromId,
} from "../../_helpers/arrangers";
// import { getDateFromTicks } from "../../_helpers/arrangers";
import ContextMenu from "../parts/ContextMenu.vue";
// import AddLogManual from "../parts/AddLogManual.vue";
import ReportService from "../../services/report.service";
import reportService from "../../services/report.service";
// import userService from "../../services/user.service";

export default {
  name: "EditOutsideEvent",

  components: {
    ContextMenu,
    // AddLogManual,
  },

  props: {
    title: String,
    employeeName: String,
    selectedDailyLog: Object,
    showContextMenuDeactivate: Boolean,
    showContextMenuForceDeparture: Boolean,
    showManualLogAdd: Boolean,
    dontShowAllLogs: Boolean,
    isMultiselect: Boolean,
  },

  data() {
    return {
      showContextMenu: false,
      selectedAccess: null,
      selectedAcesses: [],
      multipleRowsSelected: false,
      params: {
        data: [
          [
            "ndx",
            "vrijeme",
            "tip",
            "uređaj",
            "radnja",
            "vrsta odlaska",
            "info?",
          ],
        ],
        header: "row",
        columnWidth: [
          { column: 0, width: 50 },
          { column: 1, width: 120 },
          { column: 3, width: 150 },
          { column: 6, width: 100 },
        ],
        showCheck: this.isMultiselect,
        pagination: true,
        pageSize: 50,
        filter: [
          {
            column: 6,
            content: [{ text: "✅", value: "✅" }],
            method: (value, tableCell) => {
              return tableCell.data == "✅";
            },
          },
        ],
      },
    };
  },

  computed: {
    logDate() {
      return new Date(this.selectedDailyLog.logDate).toLocaleDateString(
        "sr-latn-cs"
      );
    },
  },

  methods: {
    resetUi() {
      this.params.data = [
        ["ndx", "vrijeme", "tip", "uređaj", "radnja", "vrsta odlaska", "info?"],
      ];
    },

    onSelectionChange(checkedDatas, checkedIndexs, checkedNum) {
      console.log(
        "onSelectionChange: ",
        checkedDatas,
        checkedIndexs,
        checkedNum
      );
      console.log("checked datas: ", checkedDatas);

      this.selectedAcesses = [];

      if (checkedNum > 1) {
        this.multipleRowsSelected = true;
      } else {
        this.multipleRowsSelected = false;
      }

      checkedIndexs.forEach((ndx) => {
        if (ndx === 0) return;
        console.log(ndx);

        this.selectedAcesses.push(this.selectedDailyLog.myAccessLogs[ndx - 1]);
      });
    },

    deleteSelectedEvents() {
      console.log("deleteSelectedEvents");
      console.log(this.selectedAcesses);

      // first alert
      if (
        !confirm(
          "Da li ste sigurni da želite da deaktivirate selektovane događaje?"
        )
      ) {
        return;
      }

      this.selectedAcesses.forEach((element) => {
        console.log(element);
        if (element.sender === "uhf") {
          reportService
            .ToggleAccessUhfStatusByAccessId(element.correspondingLogId, false)
            .then((response) => {
              console.log(response.statusText);
              this.$emit("accessRemoteCreated", response);
            });
        } else if (element.sender === "cam") {
          reportService
            .ToggleAccessCameraStatusByAccessId(
              element.correspondingLogId,
              false
            )
            .then((response) => {
              console.log(response.statusText);
              this.$emit("accessRemoteCreated", response);
            });
        } else if (element.sender === "remote") {
          reportService
            .ToggleAccessRemoteStatusByAccessId(
              element.correspondingLogId,
              false
            )
            .then((response) => {
              console.log(response.statusText);
              this.$emit("accessRemoteCreated", response);
            });
        } else if (element.sender === "mifare") {
          reportService
            .ToggleAccessStatusByAccessId(element.correspondingLogId, false)
            .then((response) => {
              console.log(response.statusText);
              this.$emit("accessRemoteCreated", response);
            });
        } else console.log("nothing");
      });
    },

    arrangeData() {
      let ndx = 1;
      // console.log(this.selectedDailyLog);
      let normalizedLogs = this.selectedDailyLog.normalizedAccessLogs;

      console.log("mačak");
      console.log(this.selectedDailyLog);

      // rearange selectedDailyLog.myAccessLogs
      let sortedLogs = this.selectedDailyLog.myAccessLogs.sort(this.sortByDate);

      sortedLogs.forEach((element) => {
        // console.log(element);
        let ifContains = true;
        if (this.dontShowAllLogs) {
          ifContains = ifArrayContainsObject(normalizedLogs, element);
        }

        console.log(ifContains);
        if (ifContains === true) {
          let locationName = "";

          this.params.data.push([
            ndx++,
            new Date(element.accessTime).toLocaleTimeString("sr-latn-cs"),
            getAccessTypeFromAccessLog(element, locationName),
            getDeviceFromAccessLog(element),
            getEventFromAccessLog(
              element,
              this.$store.state.general.checkpointNames
            ),
            getLeavingReasonStringFromId(element.choiceId),
            // element.choiceId == 904 ? "🏠 odlazak sa posla" : "",
            ifArrayContainsObject(normalizedLogs, element) ? "✅" : "ℹ️",
          ]);
        }
      });
    },

    // var arr = [{id:1, date:'2020-12-01'}, {id:1, date:'2020-12-15'}, {id:1, date:'2020-12-12'}]

    sortByDate(a, b) {
      if (a.accessTime < b.accessTime) {
        return -1;
      }
      if (a.accessTime > b.accessTime) {
        return 1;
      }
      return 0;
    },

    openContextMenu(e) {
      this.$refs.menu.open(e);
    },

    cmClicked(params, row) {
      console.log("hic!");
      console.log(this.selectedDailyLog);
      console.log(this.selectedDailyLog.myAccessLogs[row - 1]);
      this.selectedAccess = this.selectedDailyLog.myAccessLogs[row - 1];

      console.log("ovdje");
      console.log(params);

      this.openContextMenu(params);
    },

    cmEditClicked(accessId) {
      console.log("Edit clicked");
      this.sendEditData(accessId);
    },
    cmDeactivateClicked() {
      if (this.selectedAccess.sender === "uhf") {
        reportService
          .ToggleAccessUhfStatusByAccessId(
            this.selectedAccess.correspondingLogId,
            false
          )
          .then((response) => {
            console.log(response.statusText);
            this.$emit("accessRemoteCreated", response);
          });
      } else if (this.selectedAccess.sender === "cam") {
        reportService
          .ToggleAccessCameraStatusByAccessId(
            this.selectedAccess.correspondingLogId,
            false
          )
          .then((response) => {
            console.log(response.statusText);
            this.$emit("accessRemoteCreated", response);
          });
      } else if (this.selectedAccess.sender === "remote") {
        reportService
          .ToggleAccessRemoteStatusByAccessId(
            this.selectedAccess.correspondingLogId,
            false
          )
          .then((response) => {
            console.log(response.statusText);
            this.$emit("accessRemoteCreated", response);
          });
      } else if (this.selectedAccess.sender === "mifare") {
        reportService
          .ToggleAccessStatusByAccessId(
            this.selectedAccess.correspondingLogId,
            false
          )
          .then((response) => {
            console.log(response.statusText);
            this.$emit("accessRemoteCreated", response);
          });
      } else console.log("nothing");
    },

    sendEditData(accessId) {
      console.log("hic!!!");
      console.log(accessId);
      console.log(this.selectedAccess.accessType);
      console.log(this.selectedAccess.sender);
      console.log(this.selectedAccess.employeeId);
      console.log(this.selectedAccess.accessTime);
      console.log(this.selectedAccess.checkpointId);
      switch (this.selectedAccess.sender) {
        case "mifare":
          console.log("tip: mifare!");
          ReportService.EditAccessLogChoiceIdByEmployeeIdAndAccessTimeAndCheckpointId(
            this.selectedAccess.employeeId,
            this.selectedAccess.accessTime,
            this.selectedAccess.checkpointId,
            accessId
          ).then((response) => {
            console.log(response.data);
            this.$emit("accessRemoteCreated", response);
          });
          break;
        case "cam":
          ReportService.EditAccessCameraChoiceIdByAccessRemoteId(
            this.selectedAccess.correspondingLogId,
            accessId
          ).then((response) => {
            console.log(response.data);
            this.$emit("accessRemoteCreated", response);
          });
          break;
        case "uhf":
          console.log("tip: uhf");
          ReportService.EditAccessUhfChoiceIdByAccessRemoteId(
            this.selectedAccess.correspondingLogId,
            accessId
          ).then((response) => {
            console.log(response.data);
            this.$emit("accessRemoteCreated", response);
          });
          break;
        case "remote":
          console.log("tip: remote");
          ReportService.EditAccessRemoteChoiceIdByAccessRemoteId(
            this.selectedAccess.correspondingLogId,
            accessId
          ).then((response) => {
            console.log(response.data);
            this.$emit("accessRemoteCreated", response);
          });
          break;
        default:
          console.log("unknown type!");
          break;
      }
    },
    // const scmClickedorted = arr.sort(sortByDate);
    // console.log(sorted);
  },

  mounted() {
    this.resetUi();
    this.arrangeData();
  },
};
</script>

<style scoped>
.ev-edit-daily-log {
  margin-bottom: var(--ev-spacing-md);
}

.ev-edl-header {
  margin-bottom: var(--ev-spacing-md);
}

.ev-edl-content {
  /* No extra box/shadow — parent ManualFix wraps in ev-table-section */
}

.ev-edl-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: var(--ev-spacing-md);
  flex-wrap: wrap;
}

.ev-edl-employee-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ev-edl-date-bar {
  background: var(--ev-bg);
  border: 1px solid var(--ev-border);
  border-radius: var(--ev-radius);
  padding: 10px 16px;
  margin-bottom: var(--ev-spacing-md);
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ev-edl-date-label {
  color: var(--ev-text-muted);
  font-weight: 500;
}

.ev-edl-date-value {
  color: var(--ev-text-primary);
  font-weight: 600;
}

.ev-edl-table {
  /* table container */
}

/* Context menu divider */
.ev-context-menu-divider {
  height: 1px;
  background: var(--ev-border);
  margin: 4px 12px;
  list-style: none;
}

/* Context menu danger variant */
.ev-context-menu-item--danger {
  color: var(--ev-danger) !important;
}

.ev-context-menu-item--danger:hover {
  background-color: #fef2f2 !important;
}

/* Context menu muted variant */
.ev-context-menu-item--muted {
  color: var(--ev-text-muted) !important;
}

.ev-context-menu-item--muted:hover {
  background-color: var(--ev-bg-hover) !important;
}
</style>
